[
    {
        "percent": 10,
        "existing": true,
        "default": true
    },
    {
        "percent": 8,
        "existing": true,
        "default": false
    }
]
